import { createSlice } from '@reduxjs/toolkit'

export const deviceSlice = createSlice({
  name: 'device',
  initialState: {},
  reducers: {},
})

export default deviceSlice.reducer
